<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { reactiveOmit } from '@vueuse/core'
import {
  SwitchRoot,
  type SwitchRootEmits,
  type SwitchRootProps,
  SwitchThumb,
  useForwardPropsEmits,
} from 'reka-ui'
import { cn } from '@/shadcn/lib/utils'

const props = defineProps<SwitchRootProps & { class?: HTMLAttributes['class'] }>()

const emits = defineEmits<SwitchRootEmits>()

const delegatedProps = reactiveOmit(props, 'class')

const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
  <SwitchRoot
    data-slot="switch"
    v-bind="forwarded"
    :class="cn(
      'tw:relative tw:inline-flex tw:h-6 tw:w-11 tw:shrink-0 tw:cursor-pointer tw:rounded-full tw:border-2 tw:border-transparent tw:transition-colors tw:duration-200 tw:ease-in-out tw:focus:outline-none tw:focus:ring-2 tw:focus:ring-blue-600 tw:focus:ring-offset-2 tw:data-[state=checked]:bg-blue-600 tw:data-[state=unchecked]:bg-gray-200 tw:disabled:cursor-not-allowed tw:disabled:opacity-50',
      props.class,
    )"
  >
    <SwitchThumb
      data-slot="switch-thumb"
      :class="cn('tw:pointer-events-none tw:inline-block tw:size-5 tw:transform tw:rounded-full tw:bg-white tw:shadow tw:ring-0 tw:transition tw:duration-200 tw:ease-in-out tw:data-[state=checked]:translate-x-5 tw:data-[state=unchecked]:translate-x-0')"
    >
      <slot name="thumb" />
    </SwitchThumb>
  </SwitchRoot>
</template>
